import styled from 'styled-components';

export const StyledPlaceholder = styled.div`
  width: 100%;
  padding: 30px;
  border-radius: 3px;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
  background: ${({ theme }) => theme.COLORS.BASE};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledTitle = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  margin-bottom: 14px;
`;

export const StyledIcon = styled.img`
  height: 100%;
  width: auto;
  margin-right: 20px;
`;
